var map = {
	"./Customers_list.svg": 5869,
	"./Footer.png": 7802,
	"./HomeImage.png": 2847,
	"./Review.svg": 6111,
	"./XIDOMAINS.png": 1519,
	"./XIDOMAINSD.png": 3643,
	"./XIDOMAINSDD.png": 3751,
	"./xi-black-logo.png": 6430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1940;